import type { ActionCreator } from '@reduxjs/toolkit';
import type { SetTodayAction } from '../types';
import type { LocalDate } from '../../utilities/local-date';

export const setToday: ActionCreator<SetTodayAction> = (today: LocalDate) => {
  return {
    type: 'SET_TODAY',
    today: today.toString(),
  };
};
